import Link from "next/link";

export default function FooterMenuHelp({ number }) {
    return (
        <div className="footer-item help">
            <h6 className="footer-item__title">Help</h6>
            <ul className="footer-menu">
                <li className="footer-menu__item">
                    <Link href="/help/faq" className="footer-menu__link">FAQs</Link>
                </li>
                <li className="footer-menu__item">
                    <Link href="/help/contact" className="footer-menu__link">Contact Us</Link>
                </li>
                <li className="footer-menu__item">
                    <a
                        href={`https://api.whatsapp.com/send?phone=${number}&text=`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-menu__link whatsapp"
                    >
                        <span className="icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <g clipPath="#25D366">
                                <path
                                    d="M0.341719 7.90159C0.341344 9.2459 0.695344 10.5585 1.36847 11.7155L0.277344 15.6685L4.35434 14.6078C5.48199 15.2169 6.74543 15.536 8.02934 15.5361H8.03272C12.2712 15.5361 15.7213 12.1139 15.7232 7.90761C15.724 5.86934 14.9247 3.95269 13.4726 2.51071C12.0207 1.06885 10.0898 0.274368 8.03241 0.273438C3.79347 0.273438 0.343531 3.69545 0.341781 7.90159"
                                    fill="#25D366"
                                ></path>
                                <path
                                    d="M0.066875 7.90177C0.0664375 9.29445 0.433125 10.654 1.13025 11.8524L0 15.9471L4.22319 14.8484C5.38681 15.4779 6.69694 15.8098 8.03006 15.8103H8.0335C12.424 15.8103 15.9981 12.265 16 7.90809C16.0007 5.79659 15.1727 3.81104 13.6687 2.3174C12.1646 0.823938 10.1646 0.000868217 8.0335 0C3.64225 0 0.068625 3.54481 0.066875 7.90177ZM2.58194 11.646L2.42425 11.3976C1.76137 10.3518 1.4115 9.14326 1.412 7.90226C1.41337 4.28087 4.38363 1.33457 8.036 1.33457C9.80475 1.33532 11.467 2.01947 12.7172 3.26078C13.9674 4.5022 14.6554 6.15243 14.6549 7.9076C14.6533 11.529 11.683 14.4757 8.0335 14.4757H8.03088C6.84256 14.475 5.67712 14.1584 4.66075 13.56L4.41888 13.4177L1.91275 14.0696L2.58194 11.646Z"
                                    fill="url(#paint1_linear_9045_7846)"
                                ></path>
                                <path
                                    d="M6.04125 4.59587C5.89213 4.267 5.73519 4.26036 5.59337 4.2546C5.47725 4.24963 5.3445 4.25001 5.21187 4.25001C5.07912 4.25001 4.86344 4.29956 4.68112 4.49708C4.49862 4.69478 3.98438 5.17255 3.98438 6.14427C3.98438 7.11599 4.69769 8.05515 4.79713 8.18706C4.89669 8.31872 6.17419 10.3766 8.19744 11.1683C9.87894 11.8263 10.2211 11.6954 10.5861 11.6624C10.9511 11.6295 11.7638 11.1848 11.9296 10.7236C12.0956 10.2624 12.0956 9.86712 12.0458 9.78452C11.9961 9.70222 11.8633 9.6528 11.6642 9.55407C11.4652 9.45534 10.4865 8.97745 10.3041 8.91153C10.1216 8.84567 9.98887 8.8128 9.85612 9.01056C9.72337 9.20802 9.34219 9.6528 9.226 9.78452C9.10994 9.91655 8.99375 9.93298 8.79475 9.83419C8.59556 9.73509 7.9545 9.52678 7.19394 8.85398C6.60219 8.33044 6.20269 7.68393 6.08656 7.48616C5.97044 7.2887 6.07413 7.18167 6.17394 7.08325C6.26338 6.99475 6.37306 6.85261 6.47269 6.73732C6.57194 6.62198 6.60506 6.53968 6.67144 6.40796C6.73787 6.27611 6.70462 6.16077 6.65494 6.06198C6.60506 5.96318 6.21825 4.98638 6.04125 4.59587Z"
                                    fill="white"
                                ></path>
                                </g>
                                <defs>
                                <linearGradient
                                    id="paint0_linear_9045_7846"
                                    x1="772.568"
                                    y1="1539.78"
                                    x2="772.568"
                                    y2="0.273438"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#1FAF38"></stop>
                                    <stop offset="1" stopColor="#60D669"></stop>
                                </linearGradient>
                                <linearGradient
                                    id="paint1_linear_9045_7846"
                                    x1="800"
                                    y1="1594.71"
                                    x2="800"
                                    y2="0"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stopColor="#F9F9F9"></stop>
                                    <stop offset="1" stopColor="white"></stop>
                                </linearGradient>
                                <clipPath id="clip0_9045_7846">
                                    <rect width="16" height="16" fill="white"></rect>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span className="text">Whatsapp</span>
                    </a>
                </li>
            </ul>
        </div>
    );
}
